module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.dropdownComponent(_vm.kind), {
    tag: "component",
    attrs: {
      "index": _vm.index,
      "filter_item_selected_ids": _vm.filter_item_selected_ids,
      "uncheck_all_items": _vm.uncheck_all_items
    },
    on: {
      "item-selected-items": _vm.itemSelectedItems
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1de25bab!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/dropdown-multiple-select.vue
// module id = 1039
// module chunks = 1